<template>
    <div class="rodemap">
        <div class="mask05"></div>
        <QuestionSelect :data="data" @finish="finish"></QuestionSelect>
    </div>
</template>

<script>
    //script
    import Tools from '../../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../../scripts/Global';

    import QuestionSelect from '../../cmp/questionSelect';

    export default {
        data() {
            return {
                data: {
                    headTipImg: 'cv-03',
                    headTipTxt: '你竟听得如此沉迷，这有何难！',
                    headTipPathTxt: '',
                    headTipPath: '/rodemap/aj/09',

                    qText: '聆听乐曲',
                    qImg: '聆听乐曲',
                    errText: '聆听乐曲',
                    okText: '聆听乐曲',
                    headTipStyle: {
                        bottom: '0rem',
                    },
                    answerArr: [
                        {
                            txt: '导游似乎有话说',
                        },
                    ],
                },
            };
        },
        components: {
            QuestionSelect,
        },
        created() {
            Global.pauseAll();
            Global.audio_intor.aj_music.play()
        },
        computed: {},
        methods: {
            jump(event) {
                Global.audio_intor.aj_music.pause();
                window.Global.startPlay('aj', 'scene7_5');
                Global.yubi.aj.b4 = true;
                let headTipPath = '';
                let ybtxt = '';
                if (Object.keys(Global.yubi.aj).length >= 4) {
                    headTipPath = '/bonus?giftRoad=aj';
                } else {
                    headTipPath = '/result';
                }

                Global.curr = {
                    ...this.data,
                    headTipImg: 'cv-03',
                    headTipTxt: '拿好这个，走吧',
                    headTipPath,
                    headTipPathTxt: '前往下一处 >>',
                    ybtxt,
                    textCfg: {
                        'text-align': 'center',
                    },
                    bg: '御景亭',
                    ybResultImg: '杰',
                    ybResultHTML: `<p>4个玉璧都没集齐，还想抽奖，我先走啦。</p>
        <p>不甘心的话，再来找我就是，要是不想看见我，也可以找别人。</p>
        `,
                    ybCallback: () => {
                        if (Object.keys(Global.yubi.aj).length >= 4) {
                            setTimeout(() => {
                                window.Global.startPlay('aj', 'scene13');
                            }, 500);
                        } else {
                            setTimeout(() => {
                                window.Global.startPlay('aj', 'scene12');
                            }, 500);
                        }
                    },
                };

                this.$router.replace('/yu');

                console.log(event, 'event');
            },
            finish(event) {
                Global.audio_intor.aj_music.pause();
                Global.startPlay('aj', 'scene10_11');
                let self = this;
                setTimeout(function () {
                    self.jump()
                }, 13500)
            },
        },
    };
</script>

<style lang="scss">
    .question {
        .text {
            text-align: center !important;
        }
    }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/御景亭.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
